// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const isEmailUnusedByOtherUsers = async ({
    test,
    email,
}: {
    test: boolean,
    email: string,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleIsEmailUnusedByOtherUsers = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        boolean
    >(
        functions,
        'isEmailUnusedByOtherUsers',
    );
    return handleIsEmailUnusedByOtherUsers({
        test,
        email,
    }).then((result) => {
        const unused = result.data as boolean;
        return unused;
    }).catch((err) => {
        throw err;
    });
};

export default isEmailUnusedByOtherUsers;
